import styled from 'styled-components/macro';

const ButtonContainer = styled.div`
  text-align: center;
`;

export default ButtonContainer;
